import { authService } from '@/common/api.service';
import Axios from 'axios'
import router from '../../router/index'
import {Mixin} from "@/plugins/mixin";

const initialStates = {
    token: localStorage.getItem('access_token') ||  '',
    user : JSON.parse(localStorage.getItem('user')) ||  {},
    status: '',
    exp: localStorage.getItem('exp_token') ||  '',
    form_data: {
        first_name: '',
        last_name: '',
        phone: '',
        password: '',
        agree: false
    }
    ,
    sent:false,
   
}

const mutations = {
    auth_send_sms(state){
         state.sent=true
    },
    auth_request(state) {
        state.status = 'loading'
    },
    auth_success(state, data) {
        state.status = 'success'
        state.token  = data ? data.token : ''
        state.exp    = data ? data.exp : ''
        state.user   = data.user_data
    },
    auth_error(state) {
        state.status = 'error'
    },
    logout(state) {
        state.status = 'logout'
        state.token  = ''
        router.push('/login')
    },
    success(state, form_data) {
        state.status    = 'success'
        state.form_data = form_data
    }
}

const getters = {
    isLoggedIn: state => !!state.token,
    authStatus: state => state.status,
    user: state => state.user,
    form_data: ({form_data}) => form_data,
}

const actions = {


    sendVerifyStatus({commit}){
        commit('auth_send_sms')
    },

    /**
     * Login action to handle login user
     * 
     * @param {object} _ref 
     * @param {object} params 
     */
    login({commit}, params) {
        return new Promise((resolve, reject) => {
            commit('auth_request')
            
            authService.login(params).then(
                response => {
                    let data = response.data.data
                    
                    if (!data.has_two_factor_auth) {
                        const token = data.token
                        const exp   = data.exp
                        const user  = data.user_data

                        localStorage.setItem('access_token', token)
                        localStorage.setItem('exp_token', exp)
                        localStorage.setItem('user', JSON.stringify(user))
                        localStorage.removeItem('Admin_id')
                        Axios.defaults.headers.common['Authorization'] = 'Bearer '+token

                    }
                    commit('auth_success', data)

                    resolve(data)
                },
                error => {
                    commit('auth_error')

                    localStorage.removeItem('access_token')

                    reject(error.response)
                }
            )
        })
    },
    adminLoginToUserPanel({commit}, params) {
        return new Promise((resolve, reject) => {
            commit('auth_request')

            authService.adminLoginToUserPanel(params).then(
                response => {
                    let data = response.data.data

                    const token = data.token
                    const exp   = data.exp
                    const user  = data.user_data

                    commit('auth_success', data)

                    localStorage.setItem('access_token', token)
                    localStorage.setItem('exp_token', exp)
                    localStorage.setItem('user', JSON.stringify(user))
                    localStorage.setItem('Admin_id', data.admin_id)
                    Axios.defaults.headers.common['Authorization'] = 'Bearer '+token

                    resolve(data)
                },
                error => {
                    commit('auth_error')

                    localStorage.removeItem('access_token')

                    reject(error.response)
                }
            )
        })
    },
    backToAdminPanel({commit}, param) {
        return new Promise((resolve, reject) => {
        commit('auth_request')

            let params = {
                admin_token: param.token,
                admin_hashid: param.hashid,
            };

            authService.backToAdminPanel(params).then(
            response => {
                let data = response.data.data

                const token = data.token
                const exp   = data.exp
                const user  = data.user_data

                localStorage.setItem('access_token', token)
                localStorage.setItem('exp_token', exp)
                localStorage.setItem('user', JSON.stringify(user))
                localStorage.removeItem('Admin_id')
                Axios.defaults.headers.common['Authorization'] = 'Bearer '+token

                commit('auth_success', data)

                resolve(data)
            },
            error => {
                commit('auth_error')

                localStorage.removeItem('access_token')

                reject(error.response)
            }
            )
        })
    },

    /**
     * Handle register user
     * 
     * @param {object} _ref
     * @param {object} params
     */
    register({commit}, params) {
        return new Promise((resolve, reject) => {
            commit('auth_request')
            
            authService.register(params).then(
                response => {
                    commit('auth_success', {})
                    resolve(response.data)
                },
                error => {
                    commit('auth_error')
                    localStorage.removeItem('access_token')
                    
                    reject(error.response)
                }
            )
        })
    },

    /**
     * Handle register data
     *
     * @param {object} _ref
     * @param {object} form_data
     * @returns {*}
     */
    setRegisterData({commit}, form_data) {
        return commit('success', form_data)
    },

    /**
     * Handle to verify phone
     * 
     * @param {object} _ref
     * @param {object} params
     */
    verify({commit}, params) {
        return new Promise((resolve, reject) => {
            commit('auth_request')

            authService.verify(params).then(
                response => {
                    let data = response.data.data

                    const token = data.token
                    const exp   = data.exp
                    const user  = data.user_data
                    
                    localStorage.setItem('access_token', token)
                    localStorage.setItem('exp_token', exp)
                    localStorage.setItem('user', JSON.stringify(user))
                    Axios.defaults.headers.common['Authorization'] = 'Bearer '+token
                    
                    commit('auth_success', user)

                    resolve(data)
                },
                error => {
                    commit('auth_error')

                    localStorage.removeItem('access_token')

                    reject(error.response.data)
                }
            )
        })
    },
    verifyForLogin({commit}, params) {
        return new Promise((resolve, reject) => {
            commit('auth_request')

            authService.verifyForLogin(params).then(
                response => {
                    let data = response.data.data

                    const token = data.token
                    const exp   = data.exp
                    const user  = data.user_data

                    localStorage.setItem('access_token', token)
                    localStorage.setItem('exp_token', exp)
                    localStorage.setItem('user', JSON.stringify(user))
                    Axios.defaults.headers.common['Authorization'] = 'Bearer '+token

                    commit('auth_success', user)

                    resolve(data)
                },
                error => {
                    commit('auth_error')

                    localStorage.removeItem('access_token')

                    reject(error.response.data)
                }
            )
        })
    },
    verifyRegister({commit}, params) {
        return new Promise((resolve, reject) => {
            commit('auth_request')

            authService.verifyRegister(params).then(
                response => {
                    let data = response.data.data


                    const token = data.token
                    const exp   = data.exp
                    const user  = data.user_data
                    
                    localStorage.setItem('access_token', token)
                    localStorage.setItem('exp_token', exp)
                    localStorage.setItem('user', JSON.stringify(user))
                    Axios.defaults.headers.common['Authorization'] = 'Bearer '+token
                    
                    commit('auth_success', user)

                    resolve(data)
                },
                error => {
                    commit('auth_error')

                    localStorage.removeItem('access_token')

                    reject(error.response.data)
                }
            )
        })
    },
    verifyG2faForLogin({commit}, params) {
        return new Promise((resolve, reject) => {
            commit('auth_request')

            authService.verifyG2faForLogin(params).then(
                response => {
                    let data = response.data.data

                    const token = data.token
                    const exp   = data.exp
                    const user  = data.user_data

                    localStorage.setItem('access_token', token)
                    localStorage.setItem('exp_token', exp)
                    localStorage.setItem('user', JSON.stringify(user))
                    Axios.defaults.headers.common['Authorization'] = 'Bearer '+token

                    commit('auth_success', user)

                    resolve(data)
                },
                error => {
                    commit('auth_error')

                    localStorage.removeItem('access_token')

                    reject(error.response.data)
                }
            )
        })
    },

    /**
     * Handle to send verification code
     * 
     * @param {object} _ref
     * @param {object} params
     */
    sendVerify({commit}, params) {
        commit('auth_request')
        
        return new Promise((resolve, reject) => {
            authService.sendVerify(params).then(
                response => {
                    commit('auth_success', {})

                    resolve(response.data)
                },
                error => {
                    commit('auth_error')

                    reject(error.response.data)
                }
            )
        })
    },
    sendVerifyRegister({commit}, params) {
        commit('auth_request')
        
        return new Promise((resolve, reject) => {
            authService.sendVerifyRegister(params).then(
                response => {
                    commit('auth_success', {})

                    resolve(response.data)
                },
                error => {
                    commit('auth_error')

                    reject(error.response.data)
                }
            )
        })
    },
    sendVerifyWallet({commit}, params) {
        commit('auth_request')
        
        return new Promise((resolve, reject) => {
            authService.sendVerifyWallet(params).then(
                response => {
                    commit('auth_success', {})

                    resolve(response.data)
                },
                error => {
                    commit('auth_error')

                    reject(error.response.data)
                }
            )
        })
    },


    /**
     * Handle to logout user
     *
     * @param {object} _ref
     * @param params
     */
    logout({commit} , params) {
        commit('logout')
        return new Promise((resolve) => {
            authService.logout(params).then(
                response => {
                    localStorage.removeItem('access_token')
            
                    delete Axios.defaults.headers.common['Authorization']
                    
                    resolve()
                }
            )
        })
    },

    clearData({commit}) {
        commit('logout')
        return new Promise((resolve) => {
            localStorage.removeItem('access_token')
            delete Axios.defaults.headers.common['Authorization']
            resolve()
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}